import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiRequest } from "../../services/getApiRequest";
import { END_POINTS } from "../../Helper/Constant";
import { hideLoader, showLoader } from "../loader/loaderSlice";


/* ---------------- THUNK ---------------- */
/* ---------------- THUNK ---------------- */
export const fetchGamificationProgress = createAsyncThunk(
    "gamification/fetchProgress",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await getApiRequest(END_POINTS.GET_PROGRESS);
            if (response?.success) {
                return response.data;
            }
            return rejectWithValue("Failed to fetch progress");
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message ||
                error?.error?.message ||
                error?.message
            );
        } finally {
            dispatch(hideLoader());
        }
    }
);

/* ---------------- SLICE ---------------- */
const gamificationSlice = createSlice({
    name: "gamification",
    initialState: {
        tasks: [],
        loading: false,
        error: null,
    },
    reducers: {
        clearGamificationState: (state) => {
            state.tasks = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGamificationProgress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGamificationProgress.fulfilled, (state, action) => {
                state.loading = false;
                state.tasks = action.payload;
            })
            .addCase(fetchGamificationProgress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearGamificationState } = gamificationSlice.actions;
export default gamificationSlice.reducer;
